import styles from './loader.module.css';
import React from 'react';
import { useSelector } from 'react-redux';

const AppLoader = () => {

    const isLoader = useSelector(state=>state.appLoaderReduer.isLoader);
    /** NMU-524: what the overlay is waiting for, when the caller said. */
    const message = useSelector(state=>state.appLoaderReduer.message);

    if (!isLoader) {
        return null;
    }

    return (
        <div id="apploader" className={styles.apploader}>
            <div className={styles.container}>
                <div className={styles.inner}>
                    <div></div>
                </div>
                {/*
                  NMU-524: the spinner alone never said what it was waiting for.
                  An upload now names itself and counts up, so an editor can tell
                  "still sending" from "nothing is happening".
                */}
                {message ? <p id="apploader-message" className={styles.message}>{message}</p> : null}
            </div>
        </div>
    )

}

export default AppLoader;
